var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSec23(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 124,
    height: 124,
    viewBox: "0 0 124 124",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M61.9987 117.542C31.3604 117.542 6.45703 92.6385 6.45703 62.0002C6.45703 31.3618 31.3604 6.4585 61.9987 6.4585C92.637 6.4585 117.54 31.3618 117.54 62.0002C117.54 92.6385 92.637 117.542 61.9987 117.542ZM61.9987 14.2085C35.6487 14.2085 14.207 35.6502 14.207 62.0002C14.207 88.3502 35.6487 109.792 61.9987 109.792C88.3487 109.792 109.79 88.3502 109.79 62.0002C109.79 35.6502 88.3487 14.2085 61.9987 14.2085Z",
    fill: "#7652A3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M81.169 82.3051C80.4973 82.3051 79.8256 82.1501 79.2056 81.7368L63.189 72.1784C59.2106 69.8018 56.2656 64.5834 56.2656 59.9851V38.8018C56.2656 36.6834 58.0223 34.9268 60.1406 34.9268C62.259 34.9268 64.0156 36.6834 64.0156 38.8018V59.9851C64.0156 61.8451 65.5656 64.5834 67.1673 65.5134L83.184 75.0718C85.044 76.1568 85.6123 78.5334 84.5273 80.3934C83.7523 81.6334 82.4606 82.3051 81.169 82.3051Z",
    fill: "#7652A3"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSec23);
export default __webpack_public_path__ + "static/media/sec2-3.4633f3dc8c7de68c427864860c5c4092.svg";
export { ForwardRef as ReactComponent };